// extracted by mini-css-extract-plugin
export default {"form":"form---aXr78","formContent":"formContent---RR3BE"};